import { z } from 'zod';
export const loginSchema = z.object({
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
    password: z.string().min(1),
});
export const resetPasswordSchema = z.object({
    token: z.string().min(1),
    new_password: z.string().min(12),
});
export const forgotPasswordSchema = z.object({
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
});
// NOTE: org_owner is kept in the Zod enum for the 30-day transition period.
// Old JWTs issued before the role migration may still contain org_owner.
// TODO: Remove 'org_owner' from this enum after 2026-04-28.
export const jwtPayloadSchema = z.object({
    sub: z.string().uuid(),
    org_id: z.string().uuid().nullable(),
    role: z.enum(['super_admin', 'admin', 'org_owner', 'staff']),
    iat: z.number(),
    exp: z.number(),
    // Impersonation claims (optional — present only during impersonation)
    impersonator_id: z.string().uuid().optional(),
    impersonation_session_id: z.string().uuid().optional(),
});
//# sourceMappingURL=auth.js.map